import { Component, inject, OnInit } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
  selector: 'app-rep-reports',
  templateUrl: './rep-reports.component.html',
  styleUrls: ['./rep-reports.component.scss'],
  standalone: false,
})
export class RepReportsComponent implements OnInit {
  private ss = inject(SessionStorageService);
  rights: string[] = [];
  showPolicyReview = false;
  showPolicyTags = false;

  constructor() {}

  ngOnInit() {
    this.rights = this.ss.get('rights');
    this.showPolicyReview = this.rights.includes(
      'PMRepTopPolicyReviewOpportunitiesGrid'
    );
    this.showPolicyTags = this.rights.includes('PMRepPolicyAlertsGrid');
  }
}
